import React, { useEffect, useState } from "react";
import axios from "axios";
import PaginationTable from '../../pagination/Pagination4';


const FPS_Auth_Time = ({ dist_code, afso, date }) => {
    // const [data, setData] = useState([]);
    const [response, setResponse] = useState(null);
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(50);

  const formatDate = (dateStr) => {
  if (!dateStr) return "";
  const [year, month, day] = dateStr.split("-");
  return `${day}-${month}-${year}`;
};  

    useEffect(() => {
        if (dist_code && afso && date) {
            console.log('Fetching data for:', dist_code, afso, date);
            fetchData();
        }
    }, [dist_code, afso, date]);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (value) => {
        if (value === 'all') {
            setRowsPerPage('all');
        } else {
            setRowsPerPage(parseInt(value, 10));
        }
        setPage(0);
    };

    const fetchData = () => {
        setLoading(true);

        axios.get(`${process.env.REACT_APP_URL_HEADER}/api/auth/details`, {
            params: {
                distCode: dist_code,
                afsoCode: afso,
                date: date,
            },
        })
            .then((res) => {
                setResponse(res.data);
            })
            .catch((err) => {
                console.error(err);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    if (loading) {
        return <div>Loading...</div>;
    }

    if (response && response.data.length === 0) {
        return <div>No Data Found</div>;
    }

    if (!response) return null;
    const paginatedData = rowsPerPage === 'all'
        ? response?.data
        : response?.data?.slice(
            page * rowsPerPage,
            page * rowsPerPage + rowsPerPage
        );

    return (
        <>


            <br></br><br></br>

            <table border="1" width="90%" align="center">
                <thead>
                    <tr className="tableheader">
                        <th colSpan="7">
                            FPS Dealer/Nominee Authentication
                            (District: {response?.districtName} / AFSO: {response?.afsoName})
                           Report for {formatDate(response.date)}
                        </th>            </tr>
                    <tr className="tableheader">
                        <th>Sl.No</th>
                        <th>FPS ID</th>
                        <th>Type</th>
                        <th>Name</th>
                        <th>Total Logins</th>
                        <th>First Login</th>
                        <th>Last Login</th>
                    </tr>
                </thead>
                <tbody>
                    {paginatedData.map((row, index) => (
                        <tr key={index}>
                            <td>{page * rowsPerPage + index + 1}</td>
                            <td>{row.fpsId}</td>
                            <td>{row.type}</td>
                            <td>{row.name}</td>
                            <td>{row.totalLogins}</td>
                            <td>{row.firstLogin}</td>
                            <td>{row.lastLogin}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <br /><br />
            <div width="75%" style={{ display: 'flex', justifyContent: 'right', alignItems: 'start', width: '95%' }}>
                <PaginationTable
                    count={response?.data?.length || 0}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                /></div>
            <br />
            <br />

            <div> {page}</div>

        </>
    );
};

export default FPS_Auth_Time;